// extracted by mini-css-extract-plugin
module.exports = {"registros":"FunilVendas_registros__10ZvA","registro":"FunilVendas_registro__3Tqbl","linkCarregarMais":"FunilVendas_linkCarregarMais__4Kpr5"};